import * as consts from '../constants';
import commonFunctions from '../commonFunctions';

class tariffApi {

    static loadTariffsByNetwork(token, networkId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/tariff/byNetowrk/';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ networkId }));
        });
    }

    static loadTariffs(token, searchModel) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/filtered', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(searchModel));
        });
    }

    static loadActiveTariffs(token) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/tariff/allActive';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static loadTariff(token, id) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/get/' + id, 'GET');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static saveTariff(token, tariff) {
        return new Promise((resolve, reject) => {
            let method = 'POST';
            if (tariff.id > -1)
                method = 'PUT';

            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/save', method);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(tariff));
        });
    }

    static deleteTariff(token, tariffId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/delete/' + tariffId, 'DELETE');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static cloneTariff(token, tariffId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/clone/' + tariffId, 'PUT');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    // ******************************************************************************************************************************
    //                                      Tariff Group
    // ******************************************************************************************************************************

    static loadAllTariffGroups(token) {
        return tariffApi.loadTariffGroups(token, {
            page: 1,
            itemsPerPage: 1000,
            total: 0,
            sortName: 'name',
            sortOrder: 'asc'
        });
    }

    static loadTariffGroupsForSocio(token, networkId) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/tariff/allGroupsForNetwork/' + networkId;
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url);
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static loadTariffGroups(token, searchModel) {
        return new Promise((resolve, reject) => {
            var url = process.env.REACT_APP_BASE_URL + '/api/tariff/filteredGroups';
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, url, 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve(JSON.parse(req.response));
                    } else if (req.status === 400) {
                        reject('Attenzione la richiesta formulata è errata');
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify(searchModel));
        });
    }

    static deleteTariffGroup(token, groupId) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/deleteTariffGroup/' + groupId, 'DELETE');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send();
        });
    }

    static saveTariffGroup(token, { id, name, code }) {
        return new Promise((resolve, reject) => {
            var req = new consts.AUTHENTICATION.XXXMLHttpRequest(token, process.env.REACT_APP_BASE_URL + '/api/tariff/saveTariffGroup/', 'POST');
            req.onreadystatechange = function () {
                if (req.readyState === 4) {
                    if (req.status >= 200 && req.status < 400) {
                        resolve();
                    } else if (req.status === 400) {
                        reject(commonFunctions.errorMessage(JSON.parse(req.response).message));
                    } else if (req.status === 401 || req.status === 403) {
                        reject('Non sei autorizzato o la sessione è scaduta');
                    } else {
                        reject('Errore sul server!');
                    }
                }
            };
            req.send(JSON.stringify({ id, name, code }));
        });
    }
}

export default tariffApi;
